import React from 'react';
import { Calendar, Clock, Bell, ArrowUpRight } from 'lucide-react';
import { APP } from './DashbordApplicationTab';

const InterviewsTab = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50%       { transform: translateY(-10px); }
        }
        @keyframes pulse-ring {
          0%   { transform: scale(0.95); opacity: 0.6; }
          100% { transform: scale(1.15); opacity: 0; }
        }
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .float       { animation: float 3.5s ease-in-out infinite; }
        .pulse-ring  { animation: pulse-ring 2s ease-out infinite; }
        .fade-up-1   { animation: fadeUp 0.5s ease-out 0.1s both; }
        .fade-up-2   { animation: fadeUp 0.5s ease-out 0.25s both; }
        .fade-up-3   { animation: fadeUp 0.5s ease-out 0.4s both; }
        .fade-up-4   { animation: fadeUp 0.5s ease-out 0.55s both; }
      `}</style>

      {/* Floating icon with pulse ring */}
      <div className="relative flex items-center justify-center mb-8 float">
        {/* Pulse rings */}
        <div
          className="absolute w-28 h-28 rounded-full pulse-ring"
          style={{ backgroundColor: `${APP.primary}18` }}
        />
        <div
          className="absolute w-24 h-24 rounded-full pulse-ring"
          style={{ backgroundColor: `${APP.primary}12`, animationDelay: '0.4s' }}
        />

        {/* Main icon circle */}
        <div
          style={{
            background: `linear-gradient(135deg, ${APP.primary} 0%, #3b82f6 100%)`,
            boxShadow: `0 12px 40px ${APP.primary}40`,
          }}
          className="w-20 h-20 rounded-2xl flex items-center justify-center relative z-10"
        >
          {/* Calendar grid icon — custom SVG for a polished look */}
          <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
            {/* Calendar body */}
            <rect x="4" y="7" width="30" height="26" rx="4" fill="white" fillOpacity="0.15" />
            <rect x="4" y="7" width="30" height="26" rx="4" stroke="white" strokeWidth="2" strokeOpacity="0.8"/>
            {/* Top bar */}
            <rect x="4" y="7" width="30" height="9" rx="4" fill="white" fillOpacity="0.25" />
            {/* Pin left */}
            <rect x="11" y="3" width="3" height="8" rx="1.5" fill="white" fillOpacity="0.9" />
            {/* Pin right */}
            <rect x="24" y="3" width="3" height="8" rx="1.5" fill="white" fillOpacity="0.9" />
            {/* Grid dots */}
            <circle cx="12" cy="22" r="1.8" fill="white" fillOpacity="0.8" />
            <circle cx="19" cy="22" r="1.8" fill="white" fillOpacity="0.8" />
            <circle cx="26" cy="22" r="1.8" fill="white" fillOpacity="0.4" />
            <circle cx="12" cy="29" r="1.8" fill="white" fillOpacity="0.4" />
            <circle cx="19" cy="29" r="1.8" fill="white" fillOpacity="0.8" />
            {/* Clock accent */}
            <circle cx="26" cy="29" r="4" fill="white" fillOpacity="0.95" />
            <path d="M26 26.5V29.2L27.8 30.5" stroke={APP.primary} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>

      {/* Text content */}
      <div className="text-center max-w-md fade-up-1">
        <div
          className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[15px] font-bold uppercase tracking-widest mb-4"
          style={{ backgroundColor: APP.primaryBg, color: APP.primary }}
        >
          <Clock size={15} /> Coming soon
        </div>

        <h2
          style={{ color: APP.text }}
          className="text-2xl font-bold leading-tight mb-3"
        >
          Interview Scheduler
        </h2>

        <p style={{ color: APP.textSm }} className="text-sm leading-relaxed mb-8">
          Schedule, track, and manage all your candidate interviews in one place.
          We're building something great — stay tuned.
        </p>
      </div>

      {/* Feature preview cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 w-full max-w-lg mb-8 fade-up-2">
        {[
          {
            icon: Calendar,
            title: 'Calendar view',
            desc: 'See all interviews at a glance',
            bg: APP.primaryBg,
            color: APP.primary,
          },
          {
            icon: Clock,
            title: 'Time slots',
            desc: 'Send availability to candidates',
            bg: APP.purpleBg,
            color: APP.purple,
          },
          {
            icon: Bell,
            title: 'Reminders',
            desc: 'Auto-notify before each interview',
            bg: APP.amberBg,
            color: APP.amber,
          },
        ].map(({ icon: Icon, title, desc, bg, color }) => (
          <div
            key={title}
            style={{ backgroundColor: APP.card, border: `1px solid ${APP.border}` }}
            className="rounded-2xl p-4 flex flex-col gap-2 hover:shadow-sm transition-shadow"
          >
            <div
              className="w-8 h-8 rounded-xl flex items-center justify-center"
              style={{ backgroundColor: bg }}
            >
              <Icon size={15} style={{ color }} />
            </div>
            <p style={{ color: APP.text }} className="text-xs font-semibold">{title}</p>
            <p style={{ color: APP.textXs }} className="text-[11px] leading-relaxed">{desc}</p>
          </div>
        ))}
      </div>

    

      {/* Bottom label */}
      <p style={{ color: APP.textXs }} className="text-[15px] mt-6 fade-up-4">
        Built by the Hirees team · Coming in the next update
      </p>

    </div>
  );
};

export default InterviewsTab;